import React, { useEffect, useState } from 'react';

import { notification } from 'antd';
import Axios from 'axios';
import _ from 'lodash';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';
import { onUpdatePlaylists, useContactPlaylists } from '@hooks/API/Contact/UseContactPlaylists';
import { forceReloadPlaylistsCount } from '@hooks/API/Contact/UseContactsList';
import { useWebsites } from '@hooks/API/UseWebsites';
import { useAdjustTagUsageCount } from '@hooks/CachedLists/UseTagCatalog';

import ModelBookPublishDrawer from '@components/ContactDetails/ModelDetails/CommonComponents/BookPublishing/ModelBookPublishDrawer';
import AddBookDrawer from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/AddBookDrawer';
import BookEditorDrawer from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/BookEditorDrawer';
import { coercePlaylistArray } from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/modelDetailsBooks.utils';
import ModelDetailsBooksCard from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/ModelDetailsBooksCard';
import { ModelDetailsBooksContextProvider } from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/ModelDetailsBooksContext';

import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';
import PlaylistCoverGenerator from '@components/ImageCroppers/PlaylistCoverGenerator';
import PlayListInfoDrawer from '@components/MediaDrawer/PlayListInfoDrawer';
import PlayListPreviewDrawer from '@components/MediaDrawer/PlayListPreviewDrawer';
//import ModelContext from "@contexts/ModelContext_OLD";

import SelectPictureDrawer from '@components/SelectPicture/SelectPictureDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelDetailsBooksWrapper = ({
    contactID,
    modelPlaylists,
    onAddNewBook,
    onSelectBook,
    scope,
    readOnly,
    refreshing,
    spinning,
}) => {
    const disableQuery = modelPlaylists ? true : false;
    const { data: fetchedPlaylists, isFetching: isFetchingPlaylists } = useContactPlaylists(contactID, disableQuery);
    const { data: websiteData } = useWebsites();
    const adjustTagUsageCount = useAdjustTagUsageCount();
    const [bookPreview, setBookPreview] = useState(null);
    const [bookCover, setBookCover] = useState(null);
    const [pictureToCrop, setPictureToCrop] = useState(null);
    const [bookInfo, setBookInfo] = useState(null);
    const [isPublishDrawer, setIsPublishDrawer] = useState(false);
    const [dataforPublishDrawer, setDataforPublishDrawer] = useState(false);
    const [playlists, setPlaylists] = useState(null);

    const [editBookDrawer, setEditBookDrawer] = useState(null);
    const [addBookDrawer, setAddBookDrawer] = useState(false);
    const [booksDrawer, setBooksDrawer] = useState(false);

    //TODO: RIPRISTINARE CONTROLLO  SENZA CARICARE MODELLA
    //const viewModelBooks = useUserPermission('ViewModelBooks', currentContact && currentContact.Users.map(user => user.UserID));

    useEffect(() => {
        const fromQuery = coercePlaylistArray(fetchedPlaylists);
        const fromProp = coercePlaylistArray(modelPlaylists);
        if (!isFetchingPlaylists && Array.isArray(fromQuery)) {
            setPlaylists([...fromQuery]);
        } else if (fromProp) {
            setPlaylists([...fromProp]);
        }
    }, [isFetchingPlaylists, modelPlaylists, fetchedPlaylists]);

    const removeCover = async (book) => {
        await Axios.delete(`/playlists/removecover/${book.ID}/standard`);
        await forceReloadContact(contactID);
    };

    const publishBook = (book) => {
        if (websiteData && websiteData.length > 0) {
            setDataforPublishDrawer(book);
            setIsPublishDrawer(true);
        } else {
            notification.warning({
                message: 'No Websites Configured',
                description:
                    "There are no websites configured in the management section. Sorry, this book can't be published",
                icon: <NwIcon icon={byPrefixAndName.fass['triangle-exclamation']} />,
            });
        }
    };

    const onEditBook = (book) => {
        setEditBookDrawer(book.ID);
    };

    const onDeleteBook = async (book) => {
        try {
            await Axios.delete(`/playlists/${book.ID}`);
            // il book eliminato non usa piu' i suoi tag
            (book.Tags || []).forEach((tag) => adjustTagUsageCount(tag.ID, -1));
            onUpdatePlaylists(contactID);
        } catch (error) {
            console.error('error on deleting book', error);
        }
    };

    const cloneBook = async (book) => {
        try {
            const response = await Axios.get(`/playlists/clone/${book.ID}`);
            onUpdatePlaylists(contactID);
            setEditBookDrawer(response);
        } catch (error) {
            console.error('error on deleting book', error);
        }
    };

    const onChangeFastPackageStatus = async (book, value) => {
        try {
            const data = { PlaylistID: book.ID, FastPackage: value };
            await Axios.post('/playlists/setFastPackage', data);
            onUpdatePlaylists(contactID);
            forceReloadPlaylistsCount();
        } catch (error) {
            console.error('error on set fast package on book', error);
        }
    };

    const onChangeCompCardStatus = async (book, value) => {
        try {
            const data = { PlaylistID: book.ID, CompCard: value };
            await Axios.post('/playlists/setCompCard', data);
            onUpdatePlaylists(contactID);
            forceReloadPlaylistsCount();
        } catch (error) {
            console.error('error on set comp card on book', error);
        }
    };

    /** I favourites sono per utente: l'endpoint non prende un valore, si aggiunge o si toglie. */
    const onChangeFavouriteStatus = async (book, value) => {
        try {
            if (value) {
                await Axios.post(`/playlists/favourites/${book.ID}`);
            } else {
                await Axios.delete(`/playlists/favourites/${book.ID}`);
            }
            onUpdatePlaylists(contactID);
            forceReloadPlaylistsCount();
        } catch (error) {
            console.error('error on set favourite on book', error);
        }
    };

    const onCloseEditBookDrawer = () => {
        setEditBookDrawer();
        setAddBookDrawer(false);
    };

    const handleSelectPictureForCover = (picture) => {
        setPictureToCrop(picture.hd);
    };

    const handleClosePlaylistCoverGenerator = () => {
        setPictureToCrop(null);
        setBookCover(null);
    };

    const contextProviderProps = {
        contactID,
        modelPlaylists,
        onAddNewBook,
        onEditBook,
        onSelectBook,
        readOnly,
        refreshing,
        spinning,
        onOpenPublishDrawer: (book) => publishBook(book),
        onOpenAddBookDrawer: () => setAddBookDrawer(true),
        onOpenBookCoverDrawer: (book) => setBookCover(book),
        onOpenBookInfoDrawer: (book) => setBookInfo(book),
        onOpenBookPreviewDrawer: (book) => setBookPreview(book),
        onOpenBooksDrawer: () => setBooksDrawer(true),
        onCloneBook: (book) => cloneBook(book),
        onSetFastPackage: onChangeFastPackageStatus,
        onSetCompCard: onChangeCompCardStatus,
        onSetFavourite: onChangeFavouriteStatus,
        onRemoveCover: removeCover,
        onDeleteBook,
        websiteData,
    };

    return playlists && !refreshing ? (
        <>
            <ModelDetailsBooksContextProvider {...contextProviderProps} scope={scope}>
                <ModelDetailsBooksCard />
            </ModelDetailsBooksContextProvider>
            {isPublishDrawer && dataforPublishDrawer && websiteData && (
                <ModelBookPublishDrawer
                    onClose={() => {
                        setIsPublishDrawer(false);
                        setDataforPublishDrawer();
                    }}
                    selectedBook={dataforPublishDrawer}
                    websiteData={websiteData}
                    //books={booksToRender}
                    books={modelPlaylists}
                />
            )}
            {bookPreview && (
                <PlayListPreviewDrawer
                    playlist={bookPreview}
                    contactID={contactID}
                    onClose={() => {
                        setBookPreview();
                    }}
                />
            )}
            {bookInfo && (
                <PlayListInfoDrawer
                    playlist={bookInfo}
                    contactID={contactID}
                    onEditPlaylist={onEditBook}
                    onClose={() => {
                        setBookInfo();
                    }}
                    onUpdatePlaylists={() => {
                        onUpdatePlaylists(contactID);
                    }}
                    onDeletePlaylists={onDeleteBook}
                    onPublishBook={publishBook}
                />
            )}
            {bookCover &&
                (pictureToCrop ? (
                    <PlaylistCoverGenerator
                        playlistID={bookCover.ID}
                        contactID={contactID}
                        imageUrl={pictureToCrop}
                        onClose={handleClosePlaylistCoverGenerator}
                        coverFormatCode="Standard"
                    />
                ) : (
                    <SelectPictureDrawer
                        modelID={contactID}
                        onSelectPicture={handleSelectPictureForCover}
                        onClose={() => setBookCover(false)}
                    />
                ))}
            {editBookDrawer && (
                <BookEditorDrawer bookID={editBookDrawer} contactID={contactID} onClose={onCloseEditBookDrawer} />
            )}
            {addBookDrawer && (
                <AddBookDrawer
                    contactID={contactID}
                    onClose={() => setAddBookDrawer(false)}
                    onCreated={(book) => {
                        setEditBookDrawer(book.ID);
                        setAddBookDrawer(false);
                    }}
                />
            )}
            {booksDrawer && (
                <NwDrawer
                    title={`${playlists ? playlists.length : 0} Books`}
                    onClose={() => setBooksDrawer(false)}
                    padding={0}
                    width="75vw"
                >
                    <ModelDetailsBooksContextProvider
                        {...contextProviderProps}
                        modelPlaylists={null}
                        scope="books-drawer"
                    >
                        <ModelDetailsBooksCard />
                    </ModelDetailsBooksContextProvider>
                </NwDrawer>
            )}
        </>
    ) : (
        <Loading textBlack />
    );
};

export default ModelDetailsBooksWrapper;
